import qs from 'qs';
import {
    push
} from 'react-router-redux/actions';
import {
    REPORTS_HISTORY_PAGINATION_LIMIT,
    SET_REPORTS_LIST,
    SET_REPORTS_LIST_FETCH_STATUS,
    SET_HISTORY,
    SET_HISTORY_PAGE,
    SET_HISTORY_FETCH_STATUS,
    SET_REPORTS_LIST_OPEN_VALUE,
    SET_CREATING_REPORT_ID,
    SET_REPORTS_LIST_FILTERS,
    SET_HISTORY_MANAGE_MODE_IS_ON,
    SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES,
} from './constants';
import axios from 'axios';
import {
    printDateObjectAsISOWithoutTime,
    addDaysToDate,
    checkIfTimestampIsOlderThanXMinutes
} from '../../helpers';
import {
    API
} from '../../index';
import {
    getHistoryFetchRetriesCount,
    getReportsListLastFetchTimestamp,
    getReportsList,
    getReportsListFetchRetriesCount,
    getHistoryFilters,
    getHistoryPage
} from '../../selectors';
import {
    PAGE_CUSTOMER
} from '../../App';

export const selectReportRequest = (reportId, reportName) => dispatch => {
    return new Promise((resolve, reject) => {
        const path = PAGE_CUSTOMER.RequestReport + '/' + reportId + '/' + reportName;

        dispatch(SET_REPORTS_LIST_OPEN_ACTION(false));
        dispatch(push(path));

        return resolve(path);
    });
}

export const setReportsHistoryReporTypeFilter = (reportTypeId) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch(SET_REPORTS_LIST_FILTERS_ACTION({
            reportType: reportTypeId,
        }));

        return resolve(reportTypeId);
    });
}

export const setReportsHistoryFromDateFilter = (fromDate) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch(SET_REPORTS_LIST_FILTERS_ACTION({
            fromDate: fromDate,
        }));

        return resolve(fromDate);
    });
}

export const setReportsHistoryTilDateFilter = (tilDate) => dispatch => {
    return new Promise((resolve, reject) => {
        dispatch(SET_REPORTS_LIST_FILTERS_ACTION({
            tilDate: tilDate,
        }));

        return resolve(tilDate);
    });
}

export const getReportsCategoriesList = (forceFetch) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        dispatch(SET_REPORTS_LIST_FETCH_STATUS_ACTION(true, false));

        const store = getState();
        const lastTimestamp = getReportsListLastFetchTimestamp(store);

        if (forceFetch === false && checkIfTimestampIsOlderThanXMinutes(lastTimestamp, 5) === false) {
            dispatch(SET_REPORTS_LIST_FETCH_STATUS_ACTION(false, false, 0));
            return resolve(getReportsList(store));
        }

        return axios.get(API + 'report?' + qs.stringify({
            $limit: 99999,
            $skip: 0,
        }), {
            headers: {
                'Authorization': store.auth.token,
            },
        }).then(response => {
            return response.data;
        }).then(reportsList => {
            dispatch(SET_REPORTS_LIST_ACTION(reportsList));
            dispatch(SET_REPORTS_LIST_FETCH_STATUS_ACTION(false, false, 0));
            return resolve(reportsList);
        }).catch(error => {
            const retryCount = getReportsListFetchRetriesCount(store);
            if (retryCount < 5) {
                dispatch(SET_REPORTS_LIST_FETCH_STATUS_ACTION(true, false, retryCount + 1));
                return new Promise((resolve2, reject2) => {
                    return setTimeout(() => {
                        return dispatch(getReportsCategoriesList(true));
                    }, retryCount * 400);
                })
            } else {
                dispatch(SET_REPORTS_LIST_FETCH_STATUS_ACTION(false, true, 0));
                return reject(error);
            }
        });
    });
}

export const changeReportsHistoryFilters = (reportType, fromDate, tilDate) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const store = getState();
        const currentFilters = getHistoryFilters(store);
        const filters = {
            reportType: typeof reportType !== 'undefined' ? reportType : currentFilters.reportType,
            fromDate: typeof fromDate !== 'undefined' ? fromDate : currentFilters.fromDate,
            tilDate: typeof tilDate !== 'undefined' ? tilDate : currentFilters.tilDate,
        }
        dispatch(SET_REPORTS_LIST_FILTERS_ACTION(filters));
        return resolve(filters);
    });
}

export const getReportsHistory = (page) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const store = getState();

        page = typeof page === 'number' ? page : store.reports.historyPage;

        dispatch(SET_REPORTS_HISTORY_FETCH_STATUS_ACTION(true, false));
        dispatch(SET_REPORTS_HISTORY_PAGE_ACTION(page));

        dispatch(SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES_ACTION([]));

        const filters = getHistoryFilters(store);

        let sort = {
            $sort: {
                reportRequestId: -1,
            },
        };

        if (filters.fromDate) {
            sort = {
                ...sort,
                ['reportRequestDate[$gte]']: printDateObjectAsISOWithoutTime(filters.fromDate),
            }
        }

        if (filters.tilDate) {
            sort = {
                ...sort,
                ['reportRequestDate[$lte]']: printDateObjectAsISOWithoutTime(addDaysToDate(filters.tilDate, 1)),
            }
        }

        if (filters.reportType) {
            sort = {
                ...sort,
                ['reportId']: filters.reportType,
            }
        }

        const params = {
            $limit: REPORTS_HISTORY_PAGINATION_LIMIT,
            $skip: page * REPORTS_HISTORY_PAGINATION_LIMIT - REPORTS_HISTORY_PAGINATION_LIMIT,
            ...sort,
        }

        return axios.get(API + 'report-request?' + qs.stringify(params), {
            headers: {
                'Authorization': store.auth.token,
            },
        }).then(response => {
            return response.data;
        }).then(reportsHistory => {
            dispatch(SET_REPORTS_HISTORY_ACTION(reportsHistory));
            dispatch(SET_REPORTS_HISTORY_FETCH_STATUS_ACTION(false, false, 0));
            return resolve(reportsHistory);
        }).catch(error => {
            const retryCount = getHistoryFetchRetriesCount(store);
            if (retryCount < 5) {
                dispatch(SET_REPORTS_HISTORY_FETCH_STATUS_ACTION(true, false, retryCount + 1));
                return new Promise((resolve2, reject2) => {
                    return setTimeout(() => {
                        return dispatch(getReportsHistory(page));
                    }, retryCount * 400)
                })
            } else {
                dispatch(SET_REPORTS_HISTORY_FETCH_STATUS_ACTION(false, true, 0));
                return reject(error);
            }
        });
    });
}

export const refreshLastReportsHistoryPage = () => (dispatch, getState) => {
    return dispatch(getReportsHistory());
}

export const toggleReportsHistoryManageMode = (isOn) => (dispatch, getState) => {
    return dispatch(SET_HISTORY_MANAGE_MODE_IS_ON_ACTION(
        typeof isOn !== 'undefined' ? isOn : !getState().reports.historyManageMode.isOn
    ));
}

export const changeReportsHistoryManageSelectedEntries = (entries) => (dispatch) => {
    return dispatch(SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES_ACTION(entries));
}

export const toggleReportsHistoryManageSelectedEntry = (entry, isChecked) => (dispatch, getState) => {
    const store = getState();
    let entries = store.reports.historyManageMode.selectedEntries;

    const index = entries.findIndex(e => e === entry);
    if (index !== -1 && (typeof isChecked === 'undefined' || isChecked === false)) {
        entries = [
            ...entries.slice(0, index),
            ...entries.slice(index + 1),
        ];
    } else if (typeof isChecked === 'undefined' || isChecked === true) {
        entries = [...entries, entry];
    }

    return dispatch(SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES_ACTION(entries));
}

export const deleteReportsFromHistory = (entries) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        const store = getState();

        if (!entries || typeof entries.length === 'undefined' || entries.length <= 0) {
            return resolve(true);
        }

        return axios.delete(API + 'report-request-mass-action/[' + entries.join(',') + ']', {
            headers: {
                'Authorization': store.auth.token,
            },
        }).then(response => {
            return resolve(true);
        }).catch(error => {
            return reject(false);
        });
    });
}

export const SET_REPORTS_LIST_ACTION = (reportsList) => ({
    type: SET_REPORTS_LIST,
    payload: reportsList,
});

export const SET_REPORTS_LIST_OPEN_ACTION = (isOpen) => ({
    type: SET_REPORTS_LIST_OPEN_VALUE,
    payload: typeof isOpen === 'boolean' ? isOpen : null,
});

export const SET_REPORTS_LIST_FILTERS_ACTION = (filters) => ({
    type: SET_REPORTS_LIST_FILTERS,
    payload: filters,
});

export const SET_REPORTS_LIST_FETCH_STATUS_ACTION = (isLoading, isError, retryCount) => ({
    type: SET_REPORTS_LIST_FETCH_STATUS,
    payload: {
        ...(typeof isLoading === 'boolean' ? {
            loading: isLoading,
        } : {}),
        ...(typeof isError === 'boolean' ? {
            error: isError,
        } : {}),
        ...(typeof retryCount === 'number' ? {
            retryCount: retryCount,
        } : {}),
    },
});

export const SET_REPORTS_HISTORY_ACTION = (history) => ({
    type: SET_HISTORY,
    payload: history,
});

export const SET_REPORTS_HISTORY_PAGE_ACTION = (page) => ({
    type: SET_HISTORY_PAGE,
    payload: page,
});

export const SET_REPORTS_HISTORY_FETCH_STATUS_ACTION = (isLoading, isError, retryCount) => ({
    type: SET_HISTORY_FETCH_STATUS,
    payload: {
        ...(typeof isLoading === 'boolean' ? {
            loading: isLoading,
        } : {}),
        ...(typeof isError === 'boolean' ? {
            error: isError,
        } : {}),
        ...(typeof retryCount === 'number' ? {
            retryCount: retryCount,
        } : {}),
    },
});

export const SET_HISTORY_MANAGE_MODE_IS_ON_ACTION = (isOn) => ({
    type: SET_HISTORY_MANAGE_MODE_IS_ON,
    payload: isOn,
});

export const SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES_ACTION = (entries) => ({
    type: SET_HISTORY_MANAGE_MODE_SELECTED_ENTRIES,
    payload: entries,
});



// WEBPACK FOOTER //
// ./app/web/src/container/ReportsPage/action.js